import ListDoctor from '../Component/pages/Doctor/listDoctor';

function Doctor() {
  return (
    <div><ListDoctor /></div>
  )
}

export default Doctor